import { apiEndpointBase } from "./endpoint.config";

const base = apiEndpointBase;

export default {
  getRemainingMailCount: (communityId) =>
    `${base}/community/${communityId}/get-remaining-mail-count`,
};
